<script lang="ts">
	import { browser } from '$app/environment';
	import { page } from '$app/stores';

	let rootPage = $page.route.id?.includes('bottomNav');
	interface Props {
		style?: string;
		children?: import('svelte').Snippet;
	}

	let { style = '', children }: Props = $props();
</script>

<div
	class="container"
	class:largeScreen={rootPage}
	style={(browser ? 'animation:slide-in 0.25s ease-out;' : '') + style}
>
	{@render children?.()}
</div>

<style>
	.container {
		/* align-self: center; */
		position: relative;
		display: flex;
		gap: var(--gap);
		align-items: start;
		flex-direction: column;
		justify-content: start;
		flex: 1;
		width: 100%;
		/* max-width: 600px; */
		/* margin: 0 auto; */
		padding: var(--spacing-m);
		padding-bottom: 0;
		/* animation: slide-in 0.25s ease-out; */
		transform: translateZ(0px);
	}

	@media (max-width: 768px) {
		.container {
			padding-top: 5rem;
		}
	}
	@media (min-width: 768px) {
		.container {
			padding: var(--spacing-m);
			padding-bottom: 0;
			padding-top: 5rem;
			justify-content: center;
			flex-direction: column;
			align-items: start;
			max-width: var(--max-width);
		}
	}
	@media (min-width: 1268px) {
		.largeScreen {
			padding: var(--spacing-m);
			padding-bottom: 0;
			justify-content: center;
			flex-direction: row;
			align-items: center;
			max-width: 1200px;
		}
	}
</style>
